<template>
  <!-- Old bit.dev component -->
  <a @click="reload" href="#" class="c-base-financial-summary-reload">
    <i class="c-base-financial-summary-reload__icon icon">
      <!-- Set icon to reload -->
      <slot></slot>
    </i>
    Recarregar
  </a>
</template>

<script>
export default {
  methods: {
    reload() {
      window.location.reload(true)
    },
  },
}
</script>

<style lang="scss">
.c-base-financial-summary-reload {
  display: flex;
  align-items: center;
  color: $gray-4;

  &__icon {
    margin: 0 6px 0 0 !important;
  }
}
</style>
